import Model from "./base/model";

class Invoice extends Model{
  resourceName() {
    return "invoice";
  }

  fields() {
    return {
      plv_path: "",
      plv_name: "",
      nf_files: {jsonApi: "hasMany", type: "nf_files"},
      oficio_files: {jsonApi: "hasMany", type: "oficio_files"},
      romaneio_files: {jsonApi: "hasMany", type: "romaneio_files"},
      created_at: "",
    }
  }
}

export default new Invoice();
